import _ from 'lodash'
import { PureComponent } from 'react'
import { Table } from 'antd'

import Box from '~/core/Box'
import Tooltip from '~/core/Tooltip'
import getColor from '~/lib/getColor'

import { isInviteExpired } from './logic'
import {
    OWNER,
    OWNER_DISPLAY,
    COLLAB_DISPLAY,
    PENDING_INVITATION,
    EXPIRED_INVITATION,
    SENT,
    COLLAB_INFO,
    OWNER_INFO,
    INVITE_TYPE,
    MEMBER_TYPE,
} from './constants'
import TeamManagementActions from './TeamManagementActions'
import styles from './styles.css'

export default class TeamManagement extends PureComponent {
    getOwnerMembership = () => {
        const { quoteOwner = {} } = this.props

        return {
            __typename: MEMBER_TYPE,
            id: String(quoteOwner.id || ''),
            role: OWNER,
            user: {
                id: String(quoteOwner.id || ''),
                email: quoteOwner.email || null,
                firstName: quoteOwner.firstName || null,
                lastName: quoteOwner.lastName || null,
                enabled: quoteOwner.enabled,
            },
        }
    }

    NameCell = (text, record) => {
        const { identity: { id: userId } = {} } = this.props

        if (record.__typename !== MEMBER_TYPE) {
            return (
                <Box direction="col">
                    <span>
                        {record.firstName} {record.lastName}
                    </span>
                    <span>{record.email}</span>
                </Box>
            )
        }

        if (record.__typename === MEMBER_TYPE) {
            return (
                <Box direction="col">
                    <span style={{ fontWeight: '400' }}>
                        {record.user.firstName} {record.user.lastName}
                        {String(record.user.id) === String(userId) && ' (me)'}
                    </span>
                    {record.user.enabled !== false ? (
                        <span>{record.user.email}</span>
                    ) : (
                        <>
                            <span>{record.user.email}</span>
                            <span>(Deactivated)</span>
                        </>
                    )}
                </Box>
            )
        }
    }

    RoleCell = (text, record) => {
        const { quoteOwnerId } = this.props

        if (record.__typename === MEMBER_TYPE) {
            let title
            let role

            if (record.__typename === MEMBER_TYPE) {
                title = record.role === OWNER ? OWNER_INFO : COLLAB_INFO
                role = record.role === OWNER ? OWNER_DISPLAY : COLLAB_DISPLAY
            } else {
                title =
                    quoteOwnerId === record.user.id ? OWNER_INFO : COLLAB_INFO
                role =
                    quoteOwnerId === record.user.id
                        ? OWNER_DISPLAY
                        : COLLAB_DISPLAY
            }

            return <Tooltip title={title}>{role}</Tooltip>
        }

        if (isInviteExpired(record.createdAt)) {
            return <span>{EXPIRED_INVITATION}</span>
        }

        return <span>{record.status === SENT ? PENDING_INVITATION : ''}</span>
    }

    ActionsCell = (text, record) => {
        const {
            quoteOwnerId,
            id,
            removeMembership,
            destroyInvite,
            isLocatedInAdminPage,
            quoteOwner,
            userId: oboUserId,
        } = this.props

        const userId = Number(this.props.identity.id)

        const urlPathSplit = window.location.pathname.split('/')
        const isLocatedInBusinessAccountDetails =
            urlPathSplit[2] === 'business-account'

        return (
            <TeamManagementActions
                {...record}
                modelId={
                    record.__typename === MEMBER_TYPE ||
                    record.__typename === INVITE_TYPE
                        ? id
                        : record.id
                }
                typename={record.__typename}
                isQuoteOwner={quoteOwnerId === userId}
                showDeleteInvite={quoteOwnerId === userId}
                removeMembership={removeMembership}
                destroyInvite={destroyInvite}
                currentUser={userId}
                isLocatedInAdminPage={isLocatedInAdminPage}
                isLocatedInBusinessAccountDetails={
                    isLocatedInBusinessAccountDetails
                }
                oboUserId={oboUserId}
                quoteOwner={quoteOwner}
            />
        )
    }

    COLUMNS = [
        {
            title: 'Name',
            key: 'name',
            render: this.NameCell,
        },
        {
            title: 'Role',
            key: 'role',
            render: this.RoleCell,
            width: 245,
        },
        {
            title: 'Actions',
            key: 'actions',
            render: this.ActionsCell,
            width: 110,
        },
    ]

    render() {
        const { members, invites, showTableHeader = true } = this.props
        const data = [
            ...(_.isEmpty(members)
                ? [this.getOwnerMembership()]
                : [this.getOwnerMembership(), ...members.slice().reverse()]),
            ...invites.filter(
                invite => !invite.isOpenEnded && !invite.deletedAt, // filter out deletedAt for the softDelete latency on backend
            ),
        ]

        return (
            <Box
                border={
                    showTableHeader
                        ? null
                        : `1px solid ${getColor('antBorder')}`
                }
                borderRadius="4px"
                marginTop="8px"
                position="relative"
                overflow="hidden"
            >
                <Table
                    dataSource={data}
                    columns={this.COLUMNS}
                    rowKey="id"
                    showHeader={showTableHeader}
                    pagination={false}
                    className={styles.table}
                />
            </Box>
        )
    }
}
